import Vue from "vue";
import "./service/compatible";
import App from "./App.vue";
import router from "./router";
import getApi from "./service/index";
import { store } from "./store";
import "./assets/css/reset.css";
import "./assets/css/common.styl";
import "./components/fishPondLease/common/lease-dialog.styl";
import "./assets/js/common.js";
import "./assets/js/statistics";
import "./assets/js/filter.js";
import "@babel/polyfill";
import TableEx from "./components/tablePackage";
import echarts from "echarts/lib/echarts";
import oecharts from "echarts";
import "./common/filter";
import Alert from "./components/alert/alert.js";
Vue.prototype.$Alert = Alert;
// 通过使用一个空的Vue实例作为中央事件总线 非父子间通信
let bus = new Vue();
Vue.prototype.bus = bus;
Vue.prototype.$api = getApi;
import CDescriptions from '@/components/Descriptions';
import CDescriptionsRow from '@/components/Descriptions/DescriptionsItemRow';
import CDescriptionsItem from '@/components/Descriptions/DescriptionsItem';
Vue.component(`CDescriptions`, CDescriptions);
Vue.component(`CDescriptionsRow`, CDescriptionsRow);
Vue.component(`CDescriptionsItem`, CDescriptionsItem);
Vue.directive('throttle-button', {
  inserted: function (el, binding) {
    let timeout;
    el.addEventListener('click', () => {
      console.log(el, binding);
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
        }, 3000);
        binding.value();
      }
    });
  }
});
import {
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  Input,
  RadioGroup,
  RadioButton,
  Select,
  Option,
  OptionGroup,
  Button,
  Table,
  TableColumn,
  DatePicker,
  TimePicker,
  Tooltip,
  Form,
  FormItem,
  Icon,
  Row,
  Col,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message,
  Upload,
  Radio,
  Tabs,
  TabPane,
  Switch,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Tree,
  Scrollbar,
  Popover,
  Tag
} from "element-ui";

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Input);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Tooltip);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Upload);
Vue.use(Loading.directive);
Vue.use(Radio);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Switch);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Tree);
Vue.use(Scrollbar);
Vue.use(Popover);
Vue.use(Tag);
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;

const MESSAGE_DEFAULT_DURATION = 2500;
const messageTypes = ["success", "warning", "info", "error"];

function normalizeMessageOptions(options) {
  const normalized =
    typeof options === "string" ? { message: options } : { ...options };
  if (normalized.duration === undefined) {
    normalized.duration = MESSAGE_DEFAULT_DURATION;
  }
  return normalized;
}

function $message(options) {
  return Message(normalizeMessageOptions(options));
}

messageTypes.forEach(type => {
  $message[type] = function(options) {
    const normalized = normalizeMessageOptions(options);
    normalized.type = type;
    return Message(normalized);
  };
});

$message.close = Message.close;
$message.closeAll = Message.closeAll;
Vue.prototype.$message = $message;
Vue.prototype.$echarts = echarts;
Vue.prototype.$oecharts = oecharts;
Vue.use(TableEx);
Vue.config.productionTip = false;
console.log("当前环境变量：", process.env);

Vue.prototype.S4 = function() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};
Vue.prototype.guid = function() {
  return (
    this.S4() +
    this.S4() +
    "-" +
    this.S4() +
    "-" +
    this.S4() +
    "-" +
    this.S4() +
    "-" +
    this.S4() +
    this.S4() +
    this.S4()
  );
};

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount("#app");
